import { useRequestQuery } from "@/features/common/hooks/useRequestQuery";
import {
  JobOrderByWithRelationInput,
  JobWhereInput,
} from "@/generated/graphql-hooks";

const createdAtFilterList = [
  { label: "過去24小時", daysAgo: 1 },
  { label: "過去3日", daysAgo: 3 },
  { label: "過去7日", daysAgo: 7 },
  { label: "過去14日", daysAgo: 14 },
];

export const CreatedAtFilter = () => {
  const { query, setWhere } = useRequestQuery<
    JobWhereInput,
    JobOrderByWithRelationInput
  >();

  const setCreatedAtFilter = (daysAgo: number) => {
    const { createdAt, ...rest } = query?.where;

    if (query?.where?.createdAt?.gte === daysAgo) {
      setWhere(rest);
      return;
    }

    setWhere({
      ...rest,
      // needed to be transformed to date before applying to query
      // avoid querying the same date when copying the url and accessing this page with the url later
      // useJobListWhereQuery.tsx
      createdAt: { gte: daysAgo },
    });
  };

  return (
    <div className="space-y-4">
      {createdAtFilterList.map(({ label, daysAgo }, index) => (
        <label className="flex items-center space-x-3" key={index}>
          <input
            type="radio"
            name="createdAt"
            value={daysAgo}
            checked={query?.where?.createdAt?.gte === daysAgo}
            className="form-radio text-primary h-4 w-4 rounded-full border-gray-500 bg-transparent !ring-0 !ring-offset-0"
            onChange={() => setCreatedAtFilter(daysAgo)}
          />
          <span className="text-base font-light text-gray-900">{label}</span>
        </label>
      ))}
    </div>
  );
};
